import Swiper from 'swiper/bundle';
// import 'swiper/css/bundle';

export default function swipers() {



    // ----------------------------------------------
    // Capsule type sliders
    // ----------------------------------------------

    const capsuleSliders = document.querySelectorAll('.js-capsule-slider');

    if (capsuleSliders) {

        for(const capsuleSlider of capsuleSliders){

            const capsuleSliderNav = capsuleSlider.parentElement.querySelector('.js-capsule-slider-nav');

            new Swiper(capsuleSlider, {
                navigation: {
                    prevEl: capsuleSliderNav?.children[0],
                    nextEl: capsuleSliderNav?.children[1],
                },
                loop: true,
                // centeredSlides: false,
                breakpoints: {
                300: {
                    spaceBetween: 10,
                    slidesPerView: 1.8,
                },
                768: {
                    spaceBetween: 30,
                    slidesPerView: 3,
                },
                1025: {
                    spaceBetween: 40,
                    centeredSlides: false,
                    slidesPerView: 4,
                },
                },
            });
        }
    }
}